// extracted by mini-css-extract-plugin
module.exports = {"fixacao":"styles_fixacao__BGyE4","background":"styles_background__wNEkP"};